












import '@bukalapak/bazaar-mweb/dist/bazaar.css'
import { CategoryNode } from '@bukalapak/protocgen/src/products/mitrabangunan/product/v2/private/category_pb'
import Vue from 'vue'
import { MetaInfo } from 'vue-meta'
import CategorySlugPage from '~/components/organisms/category/slug/index.vue'
import type { CategoryProduct } from '~/types/component/landing-product'
import { MappedPaginationType } from '~/types/component/mapped-pagination-type'
import { SeoContents } from '~/types/model/seo'
import { fetchCategoryData, generateHead } from '~/utils/pages/category'

export default Vue.extend({
  name: 'CategorySlug',
  auth: false,
  components: {
    CategorySlugPage,
  },
  layout: 'MainLayout',
  middleware({ route, redirect }) {
    if (!route.params.category) {
      return redirect('/')
    }
  },
  async asyncData(ctx) {
    let category, products, pagination, contents, title, categorySlug
    try {
      const data = await fetchCategoryData(ctx, ctx.params.category, encodeURIComponent(`c/${ctx.params.category}`))
      category = data.category
      products = data.products
      pagination = data.pagination
      contents = data.contents
      title = data.title
      categorySlug = data.categorySlug
    } catch (error) {}

    return {
      category,
      products,
      pagination,
      contents,
      title,
      categorySlug,
    }
  },
  data() {
    return {
      category: {} as CategoryNode.AsObject,
      products: [] as CategoryProduct[],
      pagination: {} as MappedPaginationType,
      contents: {
        meta: {
          title: '',
          description: '',
        },
        title: '',
        list: [],
        pageDescripiton: '',
      } as SeoContents,
      title: '',
      categorySlug: '',
    }
  },
  head(): MetaInfo {
    const url = `https://www.${this.$nuxt.context.$config.cookie.domain}/c/${this.$route?.params?.category || ''}`
    const title = this.contents?.meta?.title || `Harga ${this.title} Termurah Untuk Jualan dan Distributor Material`
    const description =
      this.contents?.meta?.description ||
      `Supplier ${this.title} terlengkap dengan harga ${this.title} termurah. Tersedia berbagai merk ${this.title} berkualitas untuk bisnis toko bangunan atau proyek konstruksi anda.`
    return generateHead(url, title, description)
  },
})
